import { render, staticRenderFns } from "./WiaaCertificationDetailTile.vue?vue&type=template&id=5398ed3a&scoped=true&"
import script from "./WiaaCertificationDetailTile.vue?vue&type=script&lang=js&"
export * from "./WiaaCertificationDetailTile.vue?vue&type=script&lang=js&"
import style0 from "./WiaaCertificationDetailTile.vue?vue&type=style&index=0&id=5398ed3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5398ed3a",
  null
  
)

export default component.exports